import gql from 'graphql-tag';

export default gql`
  query flightsPage(
    $origin: IataCode
    $destination: IataCode
    $departureDate: DateTime
    $returnDate: DateTime
    $skipUserInfo: Boolean!
  ) {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        destinationAdverts(
          filters: {
            section: BOOKING_FLIGHTS
            position: BOTTOM
            origin: $origin
            destination: $destination
            departureDate: $departureDate
            returningDate: $returnDate
          }
        ) {
          content
          position
        }
      }
    }
    viewer @skip(if: $skipUserInfo) {
      loyaltyId
      loyalty {
        pointsValue
        status
      }
    }
    settings {
      loyalty {
        isRedemptionEnabledForNavitaire
      }
    }
  }
`;
